import { FindIFtttListByTrigger } from '@/axios/IFttt.js'

/** @type {Map<string, Promise>} */
const cache = new Map()

function buildCacheKey(vDeviceId, params = {}) {
  const id = String(vDeviceId || '').trim()
  const showEntry = params.ShowEntry ?? 1
  return `${id}:${showEntry}`
}

/**
 * 获取设备已绑定的 IFTTT 列表（同 vDeviceId + ShowEntry 复用 Promise）
 * @param {string|number} vDeviceId
 * @param {{ ShowEntry?: number }} [params]
 */
export function fetchIFtttListByTrigger(vDeviceId, params = { ShowEntry: 1 }) {
  const id = String(vDeviceId || '').trim()
  if (!id) {
    return Promise.reject(new Error('vDeviceId is required'))
  }

  const key = buildCacheKey(id, params)
  if (cache.has(key)) {
    return cache.get(key)
  }

  const promise = FindIFtttListByTrigger({
    vDeviceId: id,
    ...params,
  }).catch(err => {
    cache.delete(key)
    throw err
  })

  cache.set(key, promise)
  return promise
}

export function getIFtttList(res) {
  return res?.Result || []
}

export function clearIFtttListByTriggerCache(vDeviceId) {
  if (vDeviceId == null || vDeviceId === '') {
    cache.clear()
    return
  }
  const prefix = `${String(vDeviceId)}:`
  Array.from(cache.keys()).forEach(key => {
    if (key.startsWith(prefix)) {
      cache.delete(key)
    }
  })
}
